import I, { useContext as D, useState as m, useEffect as M } from "react";
import { CustomerAdapter as j } from "../../api/models/customer/customer.adapter.js";
import { getAdapter as h } from "../../api/adapter.js";
import { ScopeAdapter as C } from "../../api/models/scope/scope.adapter.js";
import { useEnvironment as F } from "../../common/hooks/environment/useEnvironment.js";
import { UrlsAPI as S } from "../../../../js/urls/index.js";
import { useMagicLink as N } from "./useMagicLink.js";
const O = I.createContext({}), b = "ch-session";
function $() {
  const { hostname: o } = window.location, e = o.split(".");
  return e.length <= 1 ? o : `.${e.slice(-2).join(".")}`;
}
function k(o) {
  return `${b}--${h(C).toCookieName(o)}`;
}
function L(o) {
  const e = `${k(o)}=`, r = decodeURIComponent(document.cookie).split(";");
  for (let n = 0; n < r.length; n += 1) {
    const s = r[n].trim();
    if (s.indexOf(e) === 0)
      return s.substring(e.length, s.length);
  }
  return null;
}
function U(o, e, i = 3650) {
  const r = $(), n = /* @__PURE__ */ new Date();
  n.setTime(n.getTime() + i * 24 * 60 * 60 * 1e3);
  let s = `${k(o)}=${e}; path=/; expires=${n.toUTCString()}; samesite=strict`;
  window.location.protocol === "https:" && (s += "; secure");
  const a = `${s};domain=${r}`;
  document.cookie = a, L(o) === null && (document.cookie = s);
}
function B(o) {
  const e = k(o), i = $(), r = (/* @__PURE__ */ new Date(0)).toUTCString();
  let n = `${e}=; path=/; expires=${r}; samesite=strict`;
  window.location.protocol === "https:" && (n += "; secure"), document.cookie = `${n}; domain=${i}`, document.cookie = n;
}
function z(o) {
  const i = new URL(window.location.toString()).searchParams.get("session");
  return i !== null ? (U(o, i), S.removeParamFromUrl("session"), i) : L(o);
}
function V(o, e, i) {
  const {
    backendBaseUrl: r,
    portalBaseUrl: n
  } = F(), [s, a] = m(null), [P, d] = m(null), [v, w] = m(!1), [x, f] = m(!1), u = N(), g = async (t) => {
    try {
      w(!0);
      const c = h(C).toQueryString(o);
      c.set("expanded_scope", "true");
      const l = await fetch(`${r}/customer/data/?${c}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${t}`
        }
      });
      if (l.status !== 200)
        throw new Error("Could not retrieve customer account.");
      const p = await l.json(), E = h(j).adapt(p);
      d(E);
    } catch (c) {
      d(null), console.error(c);
    } finally {
      w(!1), f(!0);
    }
  }, A = (t) => {
    S.removeParamFromUrl("shared_secret");
    const c = (t ?? window.location.toString()).replace(window.location.hash, ""), l = encodeURIComponent(c), p = `${n}/?portal_id=${e}&redirect_uri=${l}&action=1`;
    window.location.href = p;
  }, R = () => {
    B(o);
    const t = new URL(window.location.toString());
    t.searchParams.delete("session"), window.history.pushState({}, "", t), a(null), d(null);
  }, T = (t) => {
    U(o, t), u.complete(), a(t), g(t);
  }, _ = () => {
    u.cancel(), f(!0);
  }, y = () => s === null ? Promise.reject() : g(s);
  return M(() => {
    const t = i ?? z(o);
    if (t == null) {
      new URL(window.location.toString()).searchParams.has("shared_secret") ? u.start() : f(!0);
      return;
    }
    a(t), g(t);
  }, [i]), {
    isLoading: v,
    isResolved: x,
    scope: o,
    reFetch: y,
    token: s,
    setToken: T,
    customer: P,
    login: A,
    logout: R,
    portalId: e,
    magicLinkPending: u.isPending,
    cancelMagicLink: _
  };
}
function X() {
  return D(O);
}
export {
  b as SESSION_COOKIE_NAME,
  O as authContext,
  X as useAuth,
  V as useProvideAuth
};
//# sourceMappingURL=useAuth.js.map
